// src/services/bands.js
import { api } from "./api"; // korjaa polku tarvittaessa

/**
 * Hakee bändin slugilla TAI id:llä.
 * api.bandByIdOrSlug hoitaa:
 *  - oikean API_BASEn ja credentials: 'include'
 *  - preview-tokenin (header + query) automaattisesti URL:ista/sessionStoragesta
 *  - fallback-reitit (/bands/:slug, /bands?slug=, /admin/…)
 */
export async function fetchBandBySlug(slug /*, { previewToken } = {} */) {
  try {
    const band = await api.bandByIdOrSlug(slug);
    return { ok: true, band };
  } catch (e) {
    const err = e?.payload?.error || null;
    const code =
      e?.status === 404 ? "not_found" :
      (e?.status === 403 && err === "inactive_profile") ? "inactive_profile" :
      (e?.status === 403 && err === "unpublished_forbidden") ? "unpublished_forbidden" :
      "unknown_error";
    return { ok: false, code, detail: err };
  }
}
